import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { TECHNICAL_REVIEWER_SEARCH_START_LOADING, TECHNICAL_REVIEWER_SEARCH_END_LOADING, TECHNICAL_REVIEWER_SEARCH_LOADED, SET_TECHNICAL_REVIEWER_FILTER } from "../constants/TechnicalReviewerConstants";
import { TECHNICAL_REVIEWER_START_LOADING, TECHNICAL_REVIEWER_END_LOADING, TECHNICAL_REVIEWER_LOADED } from "../constants/TechnicalReviewerConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null,
};

const TechnicalReviewerReducer = (state = initialState, action) => {
    switch(action.type) {
        case TECHNICAL_REVIEWER_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case TECHNICAL_REVIEWER_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case TECHNICAL_REVIEWER_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_TECHNICAL_REVIEWER_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case TECHNICAL_REVIEWER_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case TECHNICAL_REVIEWER_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case TECHNICAL_REVIEWER_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default TechnicalReviewerReducer;